import React, { useState, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { getApiUrl } from '../../config/api';

const UserActivity = () => {
  const { user } = useAuth();
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      fetchUserActivity();
    }
  }, [user]);

  const fetchUserActivity = async () => {
    try {
      if (!user) {
        console.error('User not authenticated');
        return;
      }
      const token = await user.getIdToken();
      const response = await fetch(getApiUrl('/api/admin/analytics/user-activity'), {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setActivities(data.activities || []);
      }
    } catch (error) {
      console.error('Error fetching user activity:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="user-activity">
        <div className="loading-container">
          <p>Loading user activity...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="user-activity">
      <h2>User Activity</h2>
      <p>User activity analytics dashboard - coming soon!</p>
      {activities.length > 0 && (
        <div>
          <h3>Recent Activity ({activities.length} users)</h3>
          <ul>
            {activities.slice(0, 10).map((activity, index) => (
              <li key={index}>
                User: {activity.user_id} - {activity.total_activities} activities
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default UserActivity;
